module.exports = __webpack_public_path__ + "static/media/june2020_1.328e8c17.jpeg";